import { render, staticRenderFns } from "./notification-event-modal.vue?vue&type=template&id=9271d8f8&scoped=true"
import script from "./notification-event-modal.vue?vue&type=script&lang=js"
export * from "./notification-event-modal.vue?vue&type=script&lang=js"
import style0 from "./notification-event-modal.vue?vue&type=style&index=0&id=9271d8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9271d8f8",
  null
  
)

export default component.exports